import { capitalDesignTokens, createTypedSxStyles } from '@opengov/capital-mui-theme';

export const styles = createTypedSxStyles({
  reportingAppContainer: {
    height: '100%',
    width: '100%',
    backgroundColor: capitalDesignTokens.foundations.colors.gray100,
    position: 'sticky'
  }
});
